import { RunGroupFormValues } from "@features/run/RunGroupDialog/RunGroupForm"
import { SEED_FIELD_MAX, SEED_FIELD_MIN } from "@features/run/RunGroupDialog/schema"
import { TextField } from "@mui/material"
import { getErrorMessage } from "@utils/form"
import { Controller, useFormContext } from "react-hook-form"

export const RunGroupFieldSeed = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<RunGroupFormValues>()

  return (
    <Controller
      name="seed"
      control={control}
      render={({ field }) => (
        <TextField
          error={Boolean(errors[field.name])}
          helperText={getErrorMessage(errors, field.name)}
          label="Seed"
          variant="standard"
          inputProps={{
            min: SEED_FIELD_MIN,
            max: SEED_FIELD_MAX,
            type: "number",
          }}
          {...field}
        />
      )}
    />
  )
}
